import React from "react";
import D3AddPoint from '../d3AddPoint.js';
function WrapD3AddPoint() {
  return (
    <D3AddPoint/>
  );
}
export default WrapD3AddPoint;
